import type { ColumnType } from 'antd/es/table';
import type { MenuProps } from 'antd';
import CogRowActions from './CogRowActions';

export const COG_ACTIONS_COLUMN_WIDTH = 56;

export interface BuildCogActionsColumnOptions<T> {
  onView?: (record: T) => void;
  onEdit?: (record: T) => void;
  /** When set, edit appears in the menu only when this returns true. */
  editVisible?: (record: T) => boolean;
  onDelete?: (record: T) => void;
  deleteConfirm?: (record: T) => { title: string; content: string };
  editPermission?: string;
  deletePermission?: string;
  deleteDisabled?: (record: T) => boolean;
  extraItems?: (record: T) => MenuProps['items'];
  viewLabel?: string;
  editLabel?: string;
  deleteLabel?: string;
  width?: number;
  fixed?: 'right';
  showRowNumber?: boolean;
  rowNumber?: (record: T, index: number) => number;
}

export function buildCogActionsColumn<T extends object>(
  options: BuildCogActionsColumnOptions<T>,
): ColumnType<T> {
  const {
    onView,
    onEdit,
    editVisible,
    onDelete,
    deleteConfirm,
    editPermission,
    deletePermission,
    deleteDisabled,
    extraItems,
    viewLabel,
    editLabel,
    deleteLabel,
    width = COG_ACTIONS_COLUMN_WIDTH,
    fixed = 'right',
    showRowNumber = true,
    rowNumber,
  } = options;

  return {
    title: '#',
    key: 'actions',
    width,
    fixed,
    align: 'center',
    render: (_: unknown, record: T, index: number) => (
      <CogRowActions
        rowNumber={
          showRowNumber
            ? rowNumber !== undefined
              ? rowNumber(record, index)
              : index + 1
            : undefined
        }
        onView={onView ? () => onView(record) : undefined}
        onEdit={
          onEdit && (editVisible === undefined || editVisible(record))
            ? () => onEdit(record)
            : undefined
        }
        onDelete={onDelete ? () => onDelete(record) : undefined}
        deleteConfirm={deleteConfirm ? deleteConfirm(record) : undefined}
        editPermission={editPermission}
        deletePermission={deletePermission}
        deleteDisabled={deleteDisabled?.(record)}
        extraItems={extraItems?.(record)}
        viewLabel={viewLabel}
        editLabel={editLabel}
        deleteLabel={deleteLabel}
      />
    ),
  };
}
